module.exports = __webpack_public_path__ + "static/img/sandywx.4e3fa64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sandywx.png
// module id = Tp56
// module chunks = 1